import { useLazyQuery } from '@apollo/client';
import { GET_QUESTIONNAIRE_RESPONSE_HISTORY } from '../gqlSchemes/getQuestionnaireResponseHistory';

interface Author {
  type: string;
  id: string;
}

export interface QuestionnaireResponseHistoryItem {
  id: string;
  questionnaireId: string;
  status: string;
  patientId: string;
  version: number;
  author: Author | null;
  authored: string | null;
  reasonForAmendment?: string;
  mainScoreMetric: any;
  subScoreMetrics: any[];
  questionResponses: any[];
  questionStates: any[];
}

const useGetQuestionnaireResponseHistory = () => {
  const [loadVersionHistory, { loading, data }] = useLazyQuery(
    GET_QUESTIONNAIRE_RESPONSE_HISTORY,
    {
      fetchPolicy: 'no-cache',
    }
  );

  return {
    versionHistory: (data?.questionnaireResponse
      ?.getQuestionnaireResponseHistory ||
      []) as QuestionnaireResponseHistoryItem[],
    loading,
    loadVersionHistory,
  };
};

export default useGetQuestionnaireResponseHistory;
